export default "__VITE_ASSET__faf0712a__"